import styled from "styled-components";
import { ERROR } from "@streeteasy/design-system/colors";
import colors from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";
import Title from "@streeteasy/design-system/deprecated/Title";
import XButton from "@streeteasy/design-system/deprecated/XButton";

import SEModal from "src/shared/components/SEModal";

const isRequiredScenario = scenario =>
  [
    "ContactConfirmation",
    "RegisterIndustryConfirmation",
    "ResetPasswordConfirmation",
    "ShareConfirmation",
    "VerificationSent"
  ].includes(scenario);

const AgentBox = styled.a`
  align-items: center;
  border: 1px solid ${colors.rabbitGrey};
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.07);
  display: flex;
  padding: 34px 30px;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  @media screen and (max-width: 660px) {
    margin: 4px -14px 22px;
    padding-bottom: 24px;
    padding-top: 24px;
  }
`;

const AgentBoxDetails = styled.div`
  max-width: 165px;
  padding-left: 29px;
`;

const AgentBoxWrapper = styled.div`
  padding: 0 70px;
`;

const SignInWrapper = styled.div`
  padding: 0 0 20px;
`;

const AuthModal = styled(SEModal)`
  form {
    margin-bottom: 0;
  }
`;

const AuthModalWrap = styled.div`
  button[class^="XButton"] {
    z-index: 100;
  }

  @media screen and (max-width: 660px) {
    div[class^="styled__CloseButtonWrapper"] {
      button[class^="XButton"] {
        display: ${({ scenario }) =>
          isRequiredScenario(scenario) ? "block" : "none"};
      }
    }
  }

  & * {
    -webkit-font-smoothing: antialiased;
    box-sizing: border-box;
  }
`;

const CloseButton = styled(XButton)`
  height: 16px;
  position: absolute;
  right: 25px;
  top: 25px;
  width: 16px;
`;

const ConfirmationWrapper = styled.div`
  min-height: ${({ minHeight }) => (minHeight ? 0 : "285px")};
  padding: 0 15px;

  @media screen and (max-width: 660px) {
    padding: 0 30px;
  }
`;

const ContactConfirmationLinkWrapper = styled.div`
  padding-top: 45px;
  text-align: center;

  @media screen and (max-width: 660px) {
    padding-top: 20px;
  }
`;

const CreateButton = styled.div`
  padding-bottom: 10px;
  padding-top: 7px;
`;

const ErrorText = styled(Text)`
  color: ${ERROR};
  font-size: 12px;
  padding-top: 7px;
  text-align: center;
`;
const LogoImage = styled.img`
  width: 100%;
`;

const LogoWrapper = styled.div`
  max-width: 110px;
`;

const MobileLineBrake = styled.span`
  @media screen and (max-width: 660px) {
    display: block;
  }
`;

const ModalButton = styled.div`
  padding-bottom: 10px;
  padding-top: 10px;
`;

const ModalDisclaimer = styled.div`
  display: flex;
  justify-content: center;
  padding: 7px 0 3px;
  text-align: center;
`;

const ModalContent = styled.div`
  background-color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 70px 70px 50px;
  width: 480px;

  @media screen and (max-width: 660px) {
    height: ${({ scenario }) =>
      isRequiredScenario(scenario) ? "auto" : "100vh"};
    padding-bottom: 35px;
    padding-left: 33px;
    padding-right: 33px;
    padding-top: ${({ scenario }) =>
      isRequiredScenario(scenario) ? "40px" : "80px"};
    width: ${({ scenario }) =>
      isRequiredScenario(scenario) ? "calc(100vw - 40px)" : "100vw"};
  }
`;

const ModalErrorBox = styled.div`
  color: ${ERROR};
`;

const ModalHeading = styled.div`
  padding-bottom: 16px;
  text-align: center;

  @media screen and (max-width: 660px) {
    background-color: ${({ scenario }) =>
      isRequiredScenario(scenario) ? "none" : `${colors.ink}`};
    left: 0;
    padding: ${({ scenario }) =>
      isRequiredScenario(scenario) ? "21px 0 15px" : "15px 0"};
    position: ${({ scenario }) =>
      isRequiredScenario(scenario) ? "static" : "absolute"};
    right: 0;
    top: 0;
    z-index: 101;
  }
`;

const ModalIconWrapper = styled.div`
  padding-bottom: 27px;
  padding-top: 37px;
  text-align: center;

  @media screen and (max-width: 660px) {
    padding-bottom: 0;
    padding-top: 13px;
  }
`;

const ModalInput = styled.div`
  padding-bottom: 5px;
`;

const ModalRecaptcha = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 7px 0 3px;

  @media screen and (max-width: 660px) {
    padding: 0 0 25px;
  }
`;

const ModalRecaptchaWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ModalText = styled.div`
  padding-bottom: 32px;
  text-align: center;

  @media screen and (max-width: 660px) {
    padding-bottom: 24px;
  }
`;

const SetPasswordWrapper = styled.div`
  padding-bottom: 80px;
`;

const TextBold = styled(Text)`
  font-weight: 700;
`;

const TextCopy = styled(Text)`
  color: ${colors.whaleGrey};
  padding-bottom: 20px;
  padding-top: 10px;
  text-align: center;
`;

const ModalTitle = styled(Title).attrs({
  as: "h3"
})`
  @media screen and (max-width: 660px) {
    color: ${({ scenario }) =>
      isRequiredScenario(scenario) ? `${colors.whaleGrey}` : "white"};
    font-size: ${({ scenario }) =>
      isRequiredScenario(scenario) ? "28px" : "16px"};
    font-weight: ${({ scenario }) =>
      isRequiredScenario(scenario) ? "300" : "700"};
    margin: ${props => (props.isReducedWidth ? "0 auto" : "auto")};
    max-width: ${props => (props.isReducedWidth ? "200px" : "auto")};
  }
`;

const ModalCompleteText = styled(ModalTitle)`
  margin: 0 -20px;
`;

const SplittedDivider = styled.div`
  align-items: center;
  display: flex;
  padding: 8px 0 18px;

  &::before,
  &::after {
    background: ${colors.foxGrey};
    content: "";
    display: block;
    height: 1px;
    width: 100%;
  }
`;

const PaddedText = styled.div`
  padding: 0 15px;
`;

const SecondaryButton = styled.p`
  margin-bottom: 0;
  padding-top: 22px;
  text-align: center;
`;

const SecondaryPasswordButton = styled(SecondaryButton)`
  padding-top: 45px;
`;

const XButtonWrapper = styled.div`
  display: none;

  @media screen and (max-width: 660px) {
    display: block;
    left: 13px;
    position: absolute;
    top: 13px;

    & button {
      height: 21px;
      width: 21px;

      &:after,
      &:before {
        background-color: white;
        height: 21px;
        top: 0;
        width: 2px;
      }
    }
  }
`;

SignInWrapper.displayName = "SignInWrapper";
ContactConfirmationLinkWrapper.displayName = "ContactConfirmationLinkWrapper";
SecondaryButton.displayName = "SecondaryButton";
SecondaryPasswordButton.displayName = "SecondaryPasswordButton";

export {
  AgentBox,
  AgentBoxDetails,
  AgentBoxWrapper,
  SignInWrapper,
  AuthModal,
  AuthModalWrap,
  CloseButton,
  ContactConfirmationLinkWrapper,
  ConfirmationWrapper,
  CreateButton,
  ErrorText,
  LogoImage,
  LogoWrapper,
  MobileLineBrake,
  ModalButton,
  ModalDisclaimer,
  ModalCompleteText,
  ModalContent,
  ModalErrorBox,
  ModalHeading,
  ModalIconWrapper,
  ModalInput,
  ModalRecaptcha,
  ModalRecaptchaWrapper,
  ModalText,
  ModalTitle,
  PaddedText,
  SecondaryButton,
  SecondaryPasswordButton,
  SetPasswordWrapper,
  SplittedDivider,
  TextBold,
  TextCopy,
  XButtonWrapper
};
